import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";

@ModuleName("LessonPackageStorage")
export class LessonPackageStorage implements AxInit {
    AxInit(init): void {
        const url = new URL(window.location.href);
        const options = url.searchParams.getAll("options[]") as string[];


        if (options.length > 0) {
            const optionsValid = options.reduce((b, curr) => b && !Number.isNaN(parseInt(curr)), true);

            if (optionsValid) {
                this.setDefaultLevelStorage(options.map(x => parseInt(x)));
                window.history.replaceState({}, document.title, window.location.pathname);
            }
        }
    }

    setDefaultLevelStorage(levels: number[]) {
        this.saveItem("lessonLevel", levels);
    }

    getDefaultLevelStorage() {
       return  this.getItem<number[]>("lessonLevel");
    }

    cleanDefaultLevelStorage() {
        this.removeItem("lessonLevel");
    }
    
    removeItem(key: string) {
        localStorage.removeItem(`ax-lp-${key}`);
    }

    saveItem(key: string, value: any) {
        localStorage.setItem(`ax-lp-${key}`, JSON.stringify(value));
    }

    getItem<T>(key: string) {
        return JSON.parse(localStorage.getItem(`ax-lp-${key}`));
    }
}